import { SelectOption } from '../classes'
import { PatientInsuranceStatus } from '../model/patient-insurance/patient-insurance-status.enum'

export const PatientInsuranceStatuses: SelectOption<PatientInsuranceStatus>[] = [
  {
    value: PatientInsuranceStatus.NotVerified,
    viewValue: 'common.not-verified',
  },
  {
    value: PatientInsuranceStatus.Active,
    viewValue: 'common.active',
  },
  {
    value: PatientInsuranceStatus.Inactive,
    viewValue: 'common.inactive',
  },
]
